import ThumbprintText from "./ThumbprintText";
export default ThumbprintText;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ThumbprintText/index.tsx